import React, { useState, Suspense } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { httpResetPassword } from '../../Hooks/user/user.post.hooks';
import { PasswordOuterContianer } from './ForgotAndReset.styles';
import HelmetHelper from '../../Components/PageHelmet/HelmetHelper.component';
// Lazy-load components
const PrimaryButton = React.lazy(
  () => import('../../Components/Buttons/PrimaryButton/PrimaryButton.component')
);
const PasswordInput = React.lazy(
  () => import('../../Components/Form/PasswordInput')
);
const Loader = React.lazy(
  () => import('../../Components/Loader/LoaderComponent.component')
);

const ResetPassword = () => {
  const navigate = useNavigate();
  const { token } = useParams();
  const [pass, setPass] = useState('');
  const [showPass, setShowPass] = useState(false);
  const [verifyPass, setVerifyPass] = useState('');
  const [verifyShowPass, setVerifyShowPass] = useState(false);
  const [err, setErr] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChangePassword = (e) => {
    setPass(e.target.value);
  };
  const handleChangeVerifyPassword = (e) => {
    setVerifyPass(e.target.value);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccess('');
    setErr('');
    setLoading(true);
    if (pass !== verifyPass) {
      setErr('Passwords do not match');
      setLoading(false);
      return;
    }
    try {
      const res = await httpResetPassword(token, pass);
      const data = await res.json();
      if (res.ok) {
        setSuccess('Password has been reset');
        setLoading(false);
        setTimeout(() => {
          navigate('/login');
        }, 5000);
      } else {
        setErr(data.msg);
        setLoading(false);
      }
    } catch (err) {
      setErr('An error has occurred');
      setLoading(false);
    }
  };

  return (
    <>
      <HelmetHelper
        title="Reset Password"
        description="Create a new password to regain access to your account."
        noIndex
      />
      <PasswordOuterContianer>
        <h2>Reset Password</h2>
        <form>
          {/* Password */}
          <Suspense fallback={<div>Loading password input...</div>}>
            <PasswordInput
              label="Password"
              span="Must be at least 6 characters"
              handleChange={(e) => {
                e.preventDefault();
                setShowPass((prev) => !prev);
              }}
              showPass={showPass}
              value={pass}
              name="pass"
              onChange={handleChangePassword}
            />
          </Suspense>
          {/* Verify Password */}
          <Suspense fallback={<div>Loading verify password input...</div>}>
            <PasswordInput
              label="Verify Password"
              handleChange={(e) => {
                e.preventDefault();
                setVerifyShowPass((prev) => !prev);
              }}
              value={verifyPass}
              onChange={handleChangeVerifyPassword}
              name="verifyPass"
              showPass={verifyShowPass}
            />
          </Suspense>
          {err && <p className="error">{err}</p>}
          {success && <p className="success">{success}</p>}
          {loading ? (
            <Suspense fallback={<div>Loading button...</div>}>
              <Loader />
            </Suspense>
          ) : (
            <Suspense fallback={<div>Loading button button...</div>}>
              <PrimaryButton
                functionName={handleSubmit}
                span="Reset Password"
              />
            </Suspense>
          )}
        </form>
      </PasswordOuterContianer>
    </>
  );
};

export default ResetPassword;
